// extracted by mini-css-extract-plugin
export default {"mainWrapper":"v8Nbw","menuItem":"kSc2t"};